import http from '@/services/http'

export default {
  sendEmail (payload) {
    return http.post('/email/send', payload)
  },
  contactUs (payload) {
    return http.post('/contactus/send', payload)
  }
}
